"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var CheckoutExtraTitle = function CheckoutExtraTitle(props) {
  var title = props.title,
    subTitle = props.subTitle;
  return /*#__PURE__*/_react["default"].createElement(StyledTitleContainer, null, /*#__PURE__*/_react["default"].createElement(StyledTitle, null, title), /*#__PURE__*/_react["default"].createElement(StyledSubTitle, null, subTitle));
};
var StyledTitleContainer = _styledComponents["default"].div.withConfig({
  displayName: "CheckoutExtraTitle__StyledTitleContainer",
  componentId: "sc-1npzdq8-0"
})(["margin-top:1px;margin-bottom:16px;"]);
var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "CheckoutExtraTitle__StyledTitle",
  componentId: "sc-1npzdq8-1"
})(["font-weight:500;font-size:14px;color:#17181a;line-height:16px;"]);
var StyledSubTitle = _styledComponents["default"].div.withConfig({
  displayName: "CheckoutExtraTitle__StyledSubTitle",
  componentId: "sc-1npzdq8-2"
})(["margin-top:4px;font-style:normal;font-weight:normal;font-size:14px;line-height:16px;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blackLight;
});
var _default = exports["default"] = CheckoutExtraTitle;